class AppConfig {
  isDev() {
    return false;
  }
}

let _instance = new AppConfig();

export default _instance;